import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Subtitle, Text } from '@/Components/Preferences/PreferencesComponents/Content';
import Switch from '@/Components/Switch/Switch';
const LabsFeature = ({ name, description, toggleFeature, isEnabled }) => {
    return (_jsxs("div", { className: "flex justify-between gap-2 md:items-center", children: [_jsxs("div", { className: "flex flex-col", children: [_jsx(Subtitle, { children: name }), _jsx(Text, { children: description })] }), _jsx(Switch, { onChange: toggleFeature, checked: isEnabled })] }));
};
export default LabsFeature;
